import React, { Fragment } from "react";
import { Button, Col, Collapse, Row, Table } from "reactstrap";
import { Link } from "react-router-dom";
import { FaExclamationTriangle, FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import { ItemDropdownMenu } from "./"
import { constants } from "../utils";
import classNames from "classnames";
import _ from "lodash";

export default function CollapseTablePmNeeds({ collapse, row, docNum, onChangeCallback, keyidx, hiddenHdrs }) {
   const data = row.children;

   function replacer(key, value) {
      // Encode # symbol in item string for inventory dashboard link
      if (typeof value === 'string')
         return value.replace(/#/g, '%23');

      return value;
   }

   return (
      <Fragment>
         <Row className="mb-1">
            <Col xs="1"><Button className="shredButton pt-0" size="sm" onClick={() => onChangeCallback(docNum)}>{collapse ? <FaMinusCircle /> : <FaPlusCircle />}</Button></Col>
            <Col xs="2">
               <ItemDropdownMenu
                  itemNumber={row.purchasedItem}
                  itemDescription={_.trim(row.purchasedItemWithDesc)}
                  attachmentCount={row.attachmentCount ?? 0}
                  colWidth={2}
                  custom
               />
            </Col>
            <Col>
               {row.purchasedItemHold ? (
                  <>
                     <FaExclamationTriangle color="red" />&nbsp;Hold
                  </>
               ) : null}
            </Col>
            <Col className={classNames("", { "text-brightRed": _.trim(row.status) === "Order" })}>{Math.round(row.amountRequired).toLocaleString()}</Col>
            <Col>{Math.round(row.amountNeeded).toLocaleString()}</Col>
            <Col>{row.status}</Col>
            <Col>{Math.round(row.plantQty).toLocaleString()}</Col>
            <Col>{Math.round(row.warehouseQty).toLocaleString()}</Col>
            {_.isEmpty(hiddenHdrs) ? null :
               _.map(hiddenHdrs, (x, idx) => {
                  return (<Col key={idx}>{Math.round(row[x.propertyName]).toLocaleString()}</Col>);
               })}
            <Col xs="1" style={{ paddingRight: "0px" }}>{Math.round(row.totalOnOrder).toLocaleString()}</Col>
         </Row>

         <Collapse isOpen={collapse} className="px-5">
            <Table size="sm" className="data-table">
               <thead className="table-header">
                  <tr>
                     <th style={{ width: "25%" }}>Item</th>
                     <th>Build Qty</th>
                     <th>On Hand</th>
                     <th>Available</th>
                     <th>On Order</th>
                     <th>Order Point</th>
                     <th>Scheduled</th>
                  </tr>
               </thead>
               <tbody>
                  {data.length > 0 && _.map(data, (datum, index) => {
                     return (
                        <tr key={index}>
                           <td className="data-cell">
                              <Link
                                 className="shredLink fw-bold"
                                 to={constants.ENDPOINTS.inventoryDashboard}
                                 onClick={() => localStorage.setItem("itemNumber", JSON.stringify({
                                    label: datum.itemWithDesc,
                                    value: datum.itemnmbr
                                 }, replacer))}
                                 target="_blank"
                              >
                                 {_.trim(datum.itemWithDesc)}
                              </Link>
                           </td>
                           <td className={"data-cell"}>{Math.round(datum.quantityToBuildPounds).toLocaleString()}</td>
                           <td className={"data-cell"}>{Math.round(datum.qtyonhnd).toLocaleString()}</td>
                           <td className={"data-cell"}>{Math.round(datum.available).toLocaleString()}</td>
                           <td className={"data-cell"}>{Math.round(datum.releaseTotal).toLocaleString()}</td>
                           <td className={"data-cell"}>{Math.round(datum.ordrpntqty).toLocaleString()}</td>
                           <td className={(datum.scheduled === true) ? "data-cell" : "data-cell text-red"}>{(datum.scheduled === true) ? "Yes" : "No"}</td>
                        </tr>
                     );
                  })}
               </tbody>
            </Table>
         </Collapse>
      </Fragment>
   );
}